import { useMemo, useState } from "react";

import { useCountries } from "app/pages/digital-marketing/monitor-and-protect/services/country/use-countries";

export const useCountriesStep = (selectedCountries: number[]) => {
    const { countries } = useCountries();
    const [searchQuery, setSearchQuery] = useState("");

    const selectedCountryIds = useMemo(() => new Set(selectedCountries), [selectedCountries]);

    const matchesSearchQuery = (countryText: string, query: string) => {
        return countryText.toLowerCase().includes(query.toLowerCase());
    };

    const selectedCountriesData = useMemo(() => {
        return selectedCountries
            .map((selectedId) => countries.find((country) => country.id === selectedId))
            .filter((country) => matchesSearchQuery(country.text, searchQuery));
    }, [selectedCountries, countries, searchQuery]);

    const filteredCountries = useMemo(() => {
        return countries.filter((country) => matchesSearchQuery(country.text, searchQuery));
    }, [countries, searchQuery]);

    return {
        selectedCountryIds,
        selectedCountriesData,
        filteredCountries,
        searchQuery,
        setSearchQuery,
    };
};
